import { ByUserPage } from './ByUserPage'
import { withByUserPage } from './withByUserPage'

const Connected = withByUserPage(ByUserPage)

export { Connected as ByUserPage }
